import script from "./MpStatCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MpStatCard.vue?vue&type=script&setup=true&lang=js"

import "./MpStatCard.vue?vue&type=style&index=0&id=791acda5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-791acda5"]])

export default __exports__